export const changeTitle = (titleName = "Mars core") => {
  document.title = titleName.replaceAll("-", " ").toLocaleUpperCase();
};
